import { BusinessDetailsFields } from '@/components/Chat/BusinessDetailsFields'
import { TravelDistanceFields } from '@/components/Chat/TravelDistanceFields'
import { FieldError } from '@/components/ui/field'
import { checksForCard, type FillApplicationState, FillCard } from '@/models/fillApplication'
import type { Org } from '@/models/user'
import { BusinessOwnerSection } from './BusinessOwnerSection'
import { FillSectionCard } from './FillSectionCard'
import { FillTabSection } from './FillTabSection'
import { FreightField } from './FreightField'
import type { BusinessCardForm } from './useBusinessCardForm'

interface BusinessCardProps {
  orgId: string
  organisation: Org
  state: FillApplicationState
  form: BusinessCardForm
}

export function BusinessCard({ orgId, organisation, state, form }: BusinessCardProps) {
  const application = organisation.currentInsuranceApplication
  const owner = application?.businessOwner

  return (
    <FillTabSection
      card={FillCard.BUSINESS}
      title="Business"
      checks={checksForCard(state.checks, FillCard.BUSINESS)}
      saving={form.saving}
    >
      <FillSectionCard title="Business details">
        <BusinessDetailsFields
          form={form.details.form}
          coverageLapseDetected={application?.coverageLapseDetected}
          showMcNumber
          hideDotNumber
          columns={2}
          idPrefix="fill-bd"
        />
        <FieldError>{form.details.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
      <BusinessOwnerSection orgId={orgId} state={state} owner={owner} form={form.owner} />
      <div className="grid gap-4 md:grid-cols-2">
        <FillSectionCard title="Travel distance" className="min-w-0">
          <TravelDistanceFields
            form={form.distance.form}
            options={application?.travelDistanceOptions ?? []}
          />
          <FieldError>{form.distance.form.formState.errors.root?.server.message}</FieldError>
        </FillSectionCard>
        <FillSectionCard title="Freight" className="min-w-0">
          <FreightField orgId={orgId} form={form.freight.form} />
          <FieldError>{form.freight.form.formState.errors.root?.server.message}</FieldError>
        </FillSectionCard>
      </div>
    </FillTabSection>
  )
}
